import Axios from "axios"
import {
  PRODUCT_CATEGORY_URLS as URLS,
  PRODUCT_DATA_URLS,
  getAddOnHeadersGlobal,
} from "../../../utils/url"
import UserService from "../../UserService"
import * as ServiceAPI from "@services"
import * as constantsAPI from "@constants"
import { JSUtils } from "@utils"

const { APIEndPoint: { API_END_POINTS = {} } = {} } = constantsAPI || {}

const CancelToken = Axios.CancelToken
const { headerAxios } = ServiceAPI

function bindPath(url, pathVal) {
  var newUrl = url
  var pathExpression = /:[a-z0-9]+/gi
  var pathVar
  while (((pathVar = pathExpression.exec(url)), pathVar != null)) {
    let pathVarName = pathVar[0]
    newUrl = newUrl.replace(
      pathVarName,
      pathVal[pathVarName.substring(1, pathVarName.length)]
    )
  }
  return newUrl
}

const productAxios = Axios.create()

productAxios.interceptors.request.use(
  async function (config) {
    const { isSaasView = false } = config || {}
    config.baseURL = config?.baseURL || URLS.baseURL
    if (UserService.isLoggedIn()) {
      if (UserService.isAuthExpired() === true) {
        const myData = await UserService.updateRefreshToken()
        if (myData === true) {
          let mydataToken = UserService.getToken((res) => {
            return res
          })
          localStorage.setItem("token", mydataToken)
          config.headers["Authorization"] = "Bearer " + mydataToken
          let tenantId =
            localStorage.getItem("tenantId") === null
              ? ""
              : localStorage.getItem("tenantId")
          config.headers["X-Tenant-ID"] = tenantId
          config.headers["X-KC-Realm-ID"] = localStorage.getItem(
            "X-KC-Realm-ID"
          )
          config.headers["X-KC-Host"] = localStorage.getItem("X-KC-Host")
          JSUtils?.getConfigAddonHeaders(config)
          getAddOnHeadersGlobal(
            config,
            isSaasView ? "saas-view" : "normal-view"
          )
        } else {
          localStorage.clear()
          UserService.doLogout()
        }
      } else {
        let tenantId =
          localStorage.getItem("tenantId") === null
            ? ""
            : localStorage.getItem("tenantId")
        config.headers["X-Tenant-ID"] = tenantId
        config.headers["X-KC-Realm-ID"] = localStorage.getItem("X-KC-Realm-ID")
        config.headers["X-KC-Host"] = localStorage.getItem("X-KC-Host")
        config.headers["Authorization"] =
          localStorage.getItem("token") === null
            ? ""
            : "Bearer " + localStorage.getItem("token")
        JSUtils?.getConfigAddonHeaders(config)
        getAddOnHeadersGlobal(config, isSaasView ? "saas-view" : "normal-view")
      }
    } else {
      localStorage.clear()
      UserService.doLogout()
    }
    if (config.headers.path) {
      try {
        config.url = bindPath(config.url, config.headers.path)
      } catch (e) {}
    }
    delete config.headers.path
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

const productCategoryApiMethods = {
  getProductHierarchy: (cancelSource = { current: undefined }) => {
    if (cancelSource?.current) {
      cancelSource.current()
    }
    return productAxios.get(URLS.endpoints.getLocationHierarchy, {
      cancelToken: new CancelToken(function executor(c) {
        cancelSource.current = c
      }),
    })
  },
  getAllProductCategories: (cancelSource = { current: undefined }) => {
    if (cancelSource?.current) {
      cancelSource.current()
    }
    return productAxios.get(URLS.endpoints.getAll, {
      cancelToken: new CancelToken(function executor(c) {
        cancelSource.current = c
      }),
    })
  },
  createCategory: (bodyData) => {
    return productAxios.post(URLS.endpoints.create, bodyData)
  },
  fetchCategory: (categoryID) => {
    return productAxios.get(URLS.endpoints.fetchCategory)
  },
  updateCategory: (categoryID, bodyData) => {
    return productAxios.patch(URLS.endpoints.updateCategory, bodyData, {
      headers: { path: { categoryID } },
    })
  },
  uploadImage: () => {
    return productAxios.post(URLS.endpoints.uploadImage)
  },
  deleteCategory: (categoryID) => {
    return productAxios.delete(URLS.endpoints.deleteCategory, {
      headers: { path: { categoryID } },
    })
  },
}

export const productDataApiMethods = {
  getProducts: (bodyData) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return headerAxios
      .post(PRODUCT_DATA_URLS.endpoints.getProducts, bodyData, {
        baseURL: PRODUCT_DATA_URLS.baseURL,
        ...options,
      })
      .then((r) => {
        let lc = r

        if (
          lc &&
          lc?.data &&
          lc?.data?.data &&
          lc?.data?.data?.docs &&
          lc?.data?.data?.docs?.length > 0
        ) {
          lc.data.data.docs = lc.data.data.docs.map((item) => {
            let { item_images = [] } = item || {}

            const [_imagesDefault = {}] = item_images.filter(
              (i) => i.default === true
            )

            const { url = "" } = _imagesDefault || {}
            let imagesDefault = []
            return {
              ...item,
              imagesDefault: url,
            }
          })
        }
        return lc
      })
      .catch((e) => {
        return e
      })
  },
  exportAllProduct: () => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return headerAxios.get(PRODUCT_DATA_URLS.endpoints.exportAllProduct, {
      baseURL: PRODUCT_DATA_URLS.baseURL,
      ...options,
    })
  },
  getAllProductsWithPagination: (page = 1, limit = 10) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return productAxios.get(PRODUCT_DATA_URLS.endpoints.getAllWithPagination, {
      baseURL: PRODUCT_DATA_URLS.baseURL,
      params: { page, limit },
      ...options,
    })
  },
  getProductGroups: (bodyData) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }

    return productAxios.post(
      PRODUCT_DATA_URLS.endpoints.getAllProductGroupsWithPagination,
      bodyData,
      { baseURL: PRODUCT_DATA_URLS.baseURL, ...options }
    )
  },
  getProductCategories: (cancelSource = { current: undefined }) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    if (cancelSource?.current) {
      cancelSource.current()
    }
    return productAxios.get(PRODUCT_DATA_URLS.endpoints.getProductCategories, {
      baseURL: PRODUCT_DATA_URLS.baseURL,
      cancelToken: new CancelToken(function executor(c) {
        cancelSource.current = c
      }),
      ...options,
    })
  },
  getProductById: (id, isLoc) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return productAxios.get(
      PRODUCT_DATA_URLS.endpoints.getProductById + "/" + id + "/" + isLoc,
      { baseURL: PRODUCT_DATA_URLS.baseURL, ...options }
    )
  },
  updateProduct: (bodyData, item_id) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return productAxios.put(
      PRODUCT_DATA_URLS.endpoints.updateProduct + "/" + item_id,
      bodyData,
      { baseURL: PRODUCT_DATA_URLS.baseURL, ...options }
    )
  },
  updateCategory: (id, bodyData) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return productAxios.put(
      PRODUCT_DATA_URLS.endpoints.updateCategory + "/" + id,
      bodyData,
      { baseURL: PRODUCT_DATA_URLS.baseURL, ...options }
    )
  },
  deleteProductCategory: (categoryId) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return productAxios.delete(
      PRODUCT_DATA_URLS.endpoints.deleteCategory + "/" + categoryId,
      { baseURL: PRODUCT_DATA_URLS.baseURL, ...options }
    )
  },
  updateProductCategoryMappings: (bodyData) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return productAxios.put(
      PRODUCT_DATA_URLS.endpoints.updateProductCategoryMappings,
      bodyData,
      { baseURL: PRODUCT_DATA_URLS.baseURL, ...options }
    )
  },
  getProductCategoryById: (categoryId) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return productAxios.get(
      PRODUCT_DATA_URLS.endpoints.getProductCategoryById + "/" + categoryId,
      { baseURL: PRODUCT_DATA_URLS.baseURL, ...options }
    )
  },
  elasticSearchLocation: (bodyData) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return productAxios.post(
      PRODUCT_DATA_URLS.endpoints.getProducts,
      bodyData,
      { baseURL: PRODUCT_DATA_URLS.baseURL, ...options }
    )
  },
  getProductsAttribute: (bodyData) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return headerAxios.post(
      PRODUCT_DATA_URLS.endpoints.getProductsAttribute,
      bodyData,
      { baseURL: PRODUCT_DATA_URLS.baseURL, ...options }
    )
  },
  searchAttributes: (bodyData) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return headerAxios.post(
      PRODUCT_DATA_URLS.endpoints.getProductsAttribute,
      bodyData,
      { baseURL: PRODUCT_DATA_URLS.baseURL, ...options }
    )
  },
  createProductAttribute: (bodyData) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return headerAxios.post(
      PRODUCT_DATA_URLS.endpoints.createProductAttribute,
      bodyData,
      { baseURL: PRODUCT_DATA_URLS.baseURL, ...options }
    )
  },
  getProductAttrById: (_id) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return productAxios.get(
      PRODUCT_DATA_URLS.endpoints.getProductAttrById + "/" + _id,
      { baseURL: PRODUCT_DATA_URLS.baseURL, ...options }
    )
  },
  updateProductAttribute: (bodyData, _id) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return productAxios.put(
      PRODUCT_DATA_URLS.endpoints.updateProductAttribute + "/" + _id,
      bodyData,
      { baseURL: PRODUCT_DATA_URLS.baseURL, ...options }
    )
  },
  getProductMapping: async (body) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    let response = await ServiceAPI.fetchCommonData(
      API_END_POINTS.getProductMappingDetails,
      body,
      options
    )
    return response
  },
  bulkUploadShekelProducts: (bodyData) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return headerAxios.post(
      PRODUCT_DATA_URLS.endpoints.bulkUploadShekelProducts,
      bodyData,
      { baseURL: PRODUCT_DATA_URLS.baseURL, ...options }
    )
  },
}
export const productStorageDataApiMethods = {
  getProducts: (bodyData) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return headerAxios.post(PRODUCT_DATA_URLS.endpoints.getProducts, bodyData, {
      baseURL: PRODUCT_DATA_URLS.baseURL,
      ...options,
    })
  },
  exportAllProduct: () => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return headerAxios.get(PRODUCT_DATA_URLS.endpoints.exportAllProduct, {
      baseURL: PRODUCT_DATA_URLS.baseURL,
      ...options,
    })
  },
  getAllProductsWithPagination: (page = 1, limit = 10) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return productAxios.get(PRODUCT_DATA_URLS.endpoints.getAllWithPagination, {
      baseURL: PRODUCT_DATA_URLS.baseURL,
      params: { page, limit },
      ...options,
    })
  },
  getProductGroups: (bodyData) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return productAxios.post(
      PRODUCT_DATA_URLS.endpoints.getAllProductGroupsWithPagination,
      bodyData,
      { baseURL: PRODUCT_DATA_URLS.baseURL, ...options }
    )
  },
  getProductCategories: (cancelSource = { current: undefined }) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    if (cancelSource?.current) {
      cancelSource.current()
    }
    return productAxios.get(PRODUCT_DATA_URLS.endpoints.getProductCategories, {
      baseURL: PRODUCT_DATA_URLS.baseURL,
      cancelToken: new CancelToken(function executor(c) {
        cancelSource.current = c
      }),
      ...options,
    })
  },
  getProductById: (id, isLoc) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return productAxios.get(
      PRODUCT_DATA_URLS.endpoints.getProductById + "/" + id + "/" + isLoc,
      { baseURL: PRODUCT_DATA_URLS.baseURL, ...options }
    )
  },
  updateProduct: (bodyData, item_id) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return productAxios.put(
      PRODUCT_DATA_URLS.endpoints.updateProduct + "/" + item_id,
      bodyData,
      { baseURL: PRODUCT_DATA_URLS.baseURL, ...options }
    )
  },
  updateCategory: (id, bodyData) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return productAxios.put(
      PRODUCT_DATA_URLS.endpoints.updateCategory + "/" + id,
      bodyData,
      { baseURL: PRODUCT_DATA_URLS.baseURL, ...options }
    )
  },
  deleteProductCategory: (categoryId) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return productAxios.delete(
      PRODUCT_DATA_URLS.endpoints.deleteCategory + "/" + categoryId,
      { baseURL: PRODUCT_DATA_URLS.baseURL, ...options }
    )
  },
  updateProductCategoryMappings: (bodyData) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return productAxios.put(
      PRODUCT_DATA_URLS.endpoints.updateProductCategoryMappings,
      bodyData,
      { baseURL: PRODUCT_DATA_URLS.baseURL, ...options }
    )
  },
  getProductCategoryById: (categoryId) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return productAxios.get(
      PRODUCT_DATA_URLS.endpoints.getProductCategoryById + "/" + categoryId,
      { baseURL: PRODUCT_DATA_URLS.baseURL, ...options }
    )
  },
  elasticSearchLocation: (bodyData) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return productAxios.post(
      PRODUCT_DATA_URLS.endpoints.getProducts,
      bodyData,
      { baseURL: PRODUCT_DATA_URLS.baseURL, ...options }
    )
  },
  getProductsAttribute: (bodyData) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return headerAxios.post(
      PRODUCT_DATA_URLS.endpoints.getProductsAttribute,
      bodyData,
      { baseURL: PRODUCT_DATA_URLS.baseURL, ...options }
    )
  },
  searchAttributes: (bodyData) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return headerAxios.post(
      PRODUCT_DATA_URLS.endpoints.getProductsAttribute,
      bodyData,
      { baseURL: PRODUCT_DATA_URLS.baseURL, ...options }
    )
  },
  createProductAttribute: (bodyData) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return headerAxios.post(
      PRODUCT_DATA_URLS.endpoints.createProductAttribute,
      bodyData,
      { baseURL: PRODUCT_DATA_URLS.baseURL, ...options }
    )
  },
  getProductAttrById: (_id) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return productAxios.get(
      PRODUCT_DATA_URLS.endpoints.getProductAttrById + "/" + _id,
      { baseURL: PRODUCT_DATA_URLS.baseURL, ...options }
    )
  },
  updateProductAttribute: (bodyData, _id) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return productAxios.put(
      PRODUCT_DATA_URLS.endpoints.updateProductAttribute + "/" + _id,
      bodyData,
      { baseURL: PRODUCT_DATA_URLS.baseURL, ...options }
    )
  },
  getProductMapping: async (body) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    let response = await ServiceAPI.fetchCommonData(
      API_END_POINTS.getStorageUnitMappings,
      body,
      options
    )
    return response
  },
  bulkUploadShekelProducts: (bodyData) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return headerAxios.post(
      PRODUCT_DATA_URLS.endpoints.bulkUploadShekelProducts,
      bodyData,
      { baseURL: PRODUCT_DATA_URLS.baseURL, ...options }
    )
  },
}

export default productCategoryApiMethods
